<template>
    <div>
        <v-row>
            <v-col>
                <select-date-in-future v-model="value.departure_date" label="Vertrekdatum"/>
            </v-col>
            <v-col>
                <select-date-in-future v-model="value.book_date" label="Boekingsdatum"/>
            </v-col>
            <v-col>
                <b-number-button-field v-model="value.adults" :max="9" :min="0" label="Aantal volwassenen" clearable/>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn-toggle
                    v-model="value.package_type_ids"
                    color="primary"
                    mandatory
                    group
                    multiple
                >
                    <v-btn x-large v-for="type in packageTypes" :value="type.id" :key="type.id">
                        {{ type.name }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
            <v-col>
                <b-text-field label="Titel" v-model="value.title" clearable/>
            </v-col>
            <v-col>
                <b-text-field label="Code" v-model="value.package_code" clearable/>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn color="secondary" @click="$emit('resetFilters')" outlined>
                    <v-icon left>mdi-arrow-u-left-top</v-icon>
                    Herstellen
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BTextField from "@/components/General/Form/BTextField";
import PackageType from "@/models/Package/PackageType/PackageType";
import SelectDateInFuture from "@/components/General/Form/Date/SelectDateInFuture";
import BNumberButtonField from "@/components/General/Form/BNumberButtonField";

export default {
    name: "SearchFields",
    components: {
        BNumberButtonField,
        SelectDateInFuture, BTextField
    },
    props: {
        value: {
            required: true,
            type: Object
        }
    },
    computed: {
        packageTypes() {
            return PackageType.query().all();
        }
    }
}
</script>
